import { render } from "./EntrepreneursPage.vue?vue&type=template&id=2ff28844&scoped=true"
import script from "./EntrepreneursPage.vue?vue&type=script&lang=js"
export * from "./EntrepreneursPage.vue?vue&type=script&lang=js"

import "./EntrepreneursPage.vue?vue&type=style&index=0&id=2ff28844&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff28844"]])

export default __exports__